// 該当するbrタグを半角スペースに置き換える
const brs = document.querySelectorAll('.columnPager_txt > a > br');
brs.forEach(br => {
	br.replaceWith(' ');
});